
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Edit, Trash2, Eye } from 'lucide-react';
import { PropBot } from '@/types/prop-bots';

interface MobilePropBotCardProps {
  bot: PropBot;
  onDeleteClick: () => void;
  onViewClick: () => void;
}

export const MobilePropBotCard = ({ bot, onDeleteClick, onViewClick }: MobilePropBotCardProps) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-medium text-base">{bot.name}</h3>
            <div className="flex gap-2 mt-1">
              <Badge 
                variant={bot.propDetails?.[0]?.is_instant_account ? 'default' : 'secondary'}
                className={bot.propDetails?.[0]?.is_instant_account ? 
                  'bg-gradient-to-r from-amber-500 to-yellow-600 text-white text-xs' : 'text-xs'}
              >
                {bot.propDetails?.[0]?.is_instant_account ? 'Instant Account' : 'Regular'}
              </Badge>
              <Badge variant={bot.status === 'active' ? 'default' : 'outline'} className="text-xs">
                {bot.status}
              </Badge>
            </div>
          </div>
          <div className="flex gap-2">
            <Button 
              variant="outline" 
              size="icon"
              onClick={onViewClick}
              title="View Details"
            >
              <Eye className="h-4 w-4" />
            </Button>
            <Button 
              variant="outline" 
              size="icon"
              onClick={() => navigate(`/admin/prop-trading/edit/${bot.id}`)}
              title="Edit Bot"
            >
              <Edit className="h-4 w-4" />
            </Button>
            <Button 
              variant="outline" 
              size="icon" 
              className="text-destructive hover:bg-destructive/10"
              onClick={onDeleteClick}
              title="Delete Bot"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid grid-cols-2 gap-3 text-sm">
          <div>
            <span className="text-muted-foreground">Prop Firm:</span>
            <p className="font-medium">{bot.propDetails?.[0]?.prop_firm || 'N/A'}</p>
          </div>
          <div>
            <span className="text-muted-foreground">Pass Rate:</span>
            <p className="font-medium">{bot.propDetails?.[0]?.pass_rate || 'N/A'}</p>
          </div>
          <div className="col-span-2">
            <span className="text-muted-foreground">Min Capital:</span>
            <p className="font-medium">
              {bot.propDetails?.[0]?.min_capital ? 
                `$${Number(bot.propDetails[0].min_capital).toLocaleString()}` : 
                'N/A'}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
